import { ListTextIconCol } from '@csp/csp-web-ui';
import { FC, memo } from 'react';
import { Maybe } from '@csp/csp-common-model';
import { BioSampleBaseCol } from '../model/BioSampleBaseCol';

type Props = BioSampleBaseCol & {
  kitDescriptionLabel: string;
  description: Maybe<string>;
  bold?: boolean;
};

export const KitDescriptionCol: FC<Props> = memo(
  ({ kitDescriptionLabel: sampleDescriptionLabel, bold, description, ...props }) => (
    <ListTextIconCol
      title={sampleDescriptionLabel}
      text={description}
      fontWeight={bold ? 500 : undefined}
      dash
      {...props}
    />
  ),
);

KitDescriptionCol.displayName = 'KitDescriptionCol';
